<template>
    <v-card :color="color" flat class="mb-1 ml-1 mr-1">

        <div class="d-flex pa-1">

            <!-- ICON -->
            <div class="align-self-center pa-3">
                <v-icon :color="iconColor">{{ icon }}</v-icon>
            </div>

            <!-- DEFAULT SLOT -->
            <div class="align-self-center pa-1 flex-grow-1" v-if="!isMasked">
                <slot></slot>
            </div>

            <!-- MASKED FIELD -->
            <masked-field
                v-if="isMasked"
                :label="variable.name.replace('_',' ')"
                :hint="hint"
                :prepend-icon="icon"
                :disabled="isDisabled"
                class="flex-grow-1"
            ></masked-field>

            <!-- DELETE BUTTON -->
            <div class="align-self-center">
                <v-btn fab
                       dark
                       small
                       left
                       text
                       tabindex="-1"
                       :disabled="!isDeletable || isDisabled"
                       @click="deleteClicked(variable)"
                >
                    <v-icon color="white">mdi-delete</v-icon>
                </v-btn>
            </div>

        </div>
    </v-card>
</template>

<script>

import {dataVariableInputMixin} from './dataVariableInputMixin';
import MaskedField from './MaskedField';

export default {

    name: "DataVariableBase",

    mixins: [dataVariableInputMixin],

    components: {
        MaskedField
    },

    methods: {
        deleteClicked(variable) {
            this.$emit('delete', variable);
        },
    }
}
</script>
